import React from 'react'

import type { IconProps } from './types'

const DoubleArrowRight: React.FC<IconProps> = ({
  size = 20,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...rest}>
      <path
        d="M5.69875 6.70949C5.30875 7.09949 5.30875 7.72949 5.69875 8.11949L9.57875 11.9995L5.69875 15.8795C5.30875 16.2695 5.30875 16.8995 5.69875 17.2895C6.08875 17.6795 6.71875 17.6795 7.10875 17.2895L11.6988 12.6995C12.0887 12.3095 12.0887 11.6795 11.6988 11.2895L7.11875 6.70949C6.72875 6.31949 6.08875 6.31949 5.69875 6.70949Z"
        fill={color}
      />
      <path
        d="M12.2886 6.70978C11.8986 7.09978 11.8986 7.72978 12.2886 8.11978L16.1686 11.9998L12.2886 15.8798C11.8986 16.2698 11.8986 16.8998 12.2886 17.2898C12.6786 17.6798 13.3086 17.6798 13.6986 17.2898L18.2886 12.6998C18.6786 12.3098 18.6786 11.6798 18.2886 11.2898L13.6986 6.69978C13.3186 6.31978 12.6786 6.31978 12.2886 6.70978Z"
        fill={color}
      />
    </svg>
  )
}

export default DoubleArrowRight
